module.exports = __webpack_public_path__ + "static/img/zichan.41f5c39c.png";